function requireViteEnv(name: string): string {
  const val = import.meta.env[name] as string | undefined;
  if (!val) {
    throw new Error(`Missing required env var: ${name}`);
  }
  return val;
}

export interface AmplifyAuthConfig {
  Auth: {
    Cognito: {
      userPoolId: string;
      userPoolClientId: string;
      passwordless: {
        webAuthn: {
          relyingPartyId: string;
        };
      };
    };
  };
}

export function getAmplifyConfig(): AmplifyAuthConfig {
  return {
    Auth: {
      Cognito: {
        userPoolId: requireViteEnv('VITE_USER_POOL_ID'),
        userPoolClientId: requireViteEnv('VITE_USER_POOL_CLIENT_ID'),
        passwordless: {
          webAuthn: {
            relyingPartyId: 'synphant.com',
          },
        },
      },
    },
  };
}
